var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoreBus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66016 16C4.66016 16.88 5.05016 17.67 5.66016 18.22V20C5.66016 20.55 6.11016 21 6.66016 21H7.66016C8.21016 21 8.66016 20.55 8.66016 20V19H16.6602V20C16.6602 20.55 17.1102 21 17.6602 21H18.6602C19.2102 21 19.6602 20.55 19.6602 20V18.22C20.2702 17.67 20.6602 16.88 20.6602 16V6C20.6602 2.5 17.0802 2 12.6602 2C8.24016 2 4.66016 2.5 4.66016 6V16ZM8.16016 17C7.33016 17 6.66016 16.33 6.66016 15.5C6.66016 14.67 7.33016 14 8.16016 14C8.99016 14 9.66016 14.67 9.66016 15.5C9.66016 16.33 8.99016 17 8.16016 17ZM17.1602 17C16.3302 17 15.6602 16.33 15.6602 15.5C15.6602 14.67 16.3302 14 17.1602 14C17.9902 14 18.6602 14.67 18.6602 15.5C18.6602 16.33 17.9902 17 17.1602 17ZM18.6602 11H6.66016V6H18.6602V11Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreBus);
export default __webpack_public_path__ + "static/media/icon-more-bus.3fde1643cad13ae21de7f34f153aa91b.svg";
export { ForwardRef as ReactComponent };